export default "__VITE_ASSET__DMHJ359k__"